<div class="grid grid-cols-3 gap-4">
	<span class="col-start-1">Status</span>
	<div class="flex items-center gap-2 col-start-2 col-span-2">
		@if (viewModel_()?.intakeForm) {
			<app-intake-status-display />
		} @else {
			<i-tabler name="circle-dashed" class="!w-6 !h-5"></i-tabler>
			<span>Not Initiated</span>
		}
	</div>
	@if (viewModel_()?.statusCounts.total > 0) {
		<!-- <ng-container *ngIf="viewModel_()?.statusCounts.total > 0"> -->
		<span class="col-start-1">Response Rate</span>
		<div class="flex items-center gap-2 col-start-2 col-span-2">
			{{ viewModel_()?.statusCounts.addedToMatter }}/{{
				viewModel_()?.statusCounts.total
			}}
			responses added to matter
			<span class="text-sm text-gray-300">
				{{ viewModel_()?.matterProgress }}%
			</span>

			@if (viewModel_()?.canShowReviewButton) {
				<button
					(click)="reviewResponses()"
					class="text-sm text-green-600 hover:text-green-800 hover:underline font-medium"
				>
					Review now
				</button>
			}
		</div>

		<span class="col-start-1">Last Updated</span>
		<span class="col-start-2 col-span-2">{{
			(viewModel_()?.intakeForm?.createdAt | date) ?? '-'
		}}</span>
	}
	<!-- </ng-container> -->
</div>
